import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, from, map, of, switchMap, withLatestFrom } from 'rxjs';
import { RadioSettings, SignType } from 'estensa-module';

import { seSignOtpSmsError, seSignOtpSmsRequest, seSignOtpSmsReset, seSignOtpSmsSuccess } from '../estensasign.actions';
import { RadioSettingsService } from '../../services/settings/radio-settings.service';
import { SissCloudOTPSmsException, SissCloudService } from './siss-cloud.service';
import { seUserLogout } from '../../root-store/root.actions';
import { EstensaBusWrapperService, IBusData } from '../../services/angularjs/estensa-bus-wrapper.service';

@Injectable()
export class SissCloudEffects {
    logout$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(seUserLogout),
                switchMap(() => this.logout()),
                catchError(() => of(undefined)),
            ),
        { dispatch: false },
    );

    requestOtpSms$ = createEffect(() =>
        this.actions$.pipe(
            ofType(seSignOtpSmsRequest),
            withLatestFrom(this.settings.radioSettingsAsync),
            exhaustMap(([action, settings]) => {
                if (!this.canRequestOtpSms(settings)) {
                    return of(seSignOtpSmsReset());
                }
                return from(this.sissCloud.requestOtpSms(action.signerId, action.signerCode, action.password)).pipe(
                    map(() => seSignOtpSmsSuccess()),
                    catchError((err) => {
                        const message = err instanceof SissCloudOTPSmsException ? err.message : 'ErrorOTPsms';

                        return of(seSignOtpSmsError({ message }));
                    }),
                );
            }),
        ),
    );

    constructor(
        private actions$: Actions,
        private settings: RadioSettingsService,
        private sissCloud: SissCloudService,
        estensaBus: EstensaBusWrapperService,
    ) {
        estensaBus.busDataFired
            .pipe(
                filter((msg: IBusData) => msg.messageType === 'ON_LOGOUT_MESSAGE'),
                switchMap(() => this.logout()),
            )
            .subscribe();
    }

    private canRequestOtpSms(settings: RadioSettings): boolean {
        return (
            settings.reportSettings.signType === SignType.SISSCloud ||
            settings.reportSettings.signType === SignType.SISSWayCloud
        );
    }

    private logout() {
        return from(this.sissCloud.logout());
    }
}
